import { render, staticRenderFns } from "./PersonalHead.vue?vue&type=template&id=fc196a92"
import script from "./PersonalHead.vue?vue&type=script&lang=js"
export * from "./PersonalHead.vue?vue&type=script&lang=js"
import style0 from "./PersonalHead.vue?vue&type=style&index=0&id=fc196a92&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports